import { PetInfo, FollowUpAction, Criteria, Weight } from '@app/core/models';
import { Tool } from '@app/shared/utils';
import { SelectedProductIds } from '@app/store/allowance';

/**
 * Order matters
 */
export enum AllowanceStep {
  Ration = 'allowance_ration',
  Redirect = 'allowance_redirect',
}

export interface AllowanceParams {
  /**
   * Tool that initiated the allowance module
   * Used for analytics purpose only, not handling scenarios
   */
  tool: Tool;
  /**
   * Tool that is not the current ongoing tool but that might be more appropriate for this pet with this product
   * For instance this will enable to display a button "create a weight loss plan" from SR or DA flow
   */
  incentiveTool?: Tool;
  /**
   * PetInfo object used accross the app
   */
  deprecatedPetInfo: PetInfo;
  /**
   * followUpAction is only set in case we initiated allowance from a weight management program (follow up);
   * It will be used to override automatically calculated currentProgram.
   */
  followUpAction?: FollowUpAction;
  /**
   * Wether the diagnosis information should be displayed inside the pet summary panel
   */
  displayDiagnosis: boolean;
  /**
   * Wether visit can be saved on exit
   */
  canSaveOnExit: boolean;
  /**
   * Reset when allowance is completed or exited
   */
  resetAfterRedirectStep: boolean;
  /**
   * Create consultation when allowance is completed before redirection
   */
  createConsultationBeforeRedirectStep: boolean;
  /**
   * Label for ration primary button
   */
  rationPrimaryActionLabel: string;

  /**
   * display ration primary button with primary background-color
   */
  rationPrimaryActionHighlighted?: boolean;

  /**
   * Route to redirect to at the end of the allowance tool;
   * Default to patient page (tab health or weight management)
   */
  forcedRedirectRoute?: string;
  /**
   * Smart reco wet product criteria, usefull to sort patho/sensibilities
   */
  criterias?: Criteria[];

  /**
   * growthChart : past weights
   */
  notSavedPastWeights?: Weight[];

  /**
   * selected products' ids
   */
  selectedProductIds?: SelectedProductIds;
}
